import React from "react";
import '../Experience/Experince.css'
import { themeContext } from "../../Context";
import { useContext } from "react";
export const Experience = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div id="Experience"
      className="experience"
      style={{
        color: darkMode ? "orange" : "none",
      }}
    >
      <div className="archivement">
        <div
          className="circle"
          style={{
            boxShadow: darkMode ? "0 0 15px white" : "none",
          }}
        >
          +1
        </div>
        <span className="years">years</span>
        <span
          className="Experience"
          style={{
            color: darkMode ? "white" : "none",
          }}
        >
          Experience
        </span>
      </div>
      <div className="archivement">
        <div
          className="circle"
          style={{
            boxShadow: darkMode ? "0 0 15px white" : "none",
          }}
        >
          +2
        </div>
        <span className="years">completed</span>
        <span
          className="Experience"
          style={{
            color: darkMode ? "white" : "none",
          }}
        >
          Real proyects
        </span>
      </div>
      <div className="archivement">
        <div
          className="circle"
          style={{
            boxShadow: darkMode ? "0 0 15px white" : "none",
          }}
        >
          +2
        </div>
        <span>Companies</span>
        <span
          style={{
            color: darkMode ? "white" : "none",
          }}
        >
          Work
        </span>
      </div>
    </div>
  );
};
